import React, { useState, useEffect } from "react";
import { Spin, Table } from "antd";
import axios from "axios";
import API from "@/api";

function DetailTable(props) {
  const { question_id, drillActions, dimField, dimValue } = props;
  const [data, setData] = useState({});
  const [spinning, setSpinning] = useState(true);
  const { metric_fields = [], data: dData = [], dim_field = {} } = data;
  useEffect(() => {
    axios
      .post(API.getFilterAndNextData, {
        question_id,
        dim_field: dimField || "",
        dim_value: dimValue || "",
        // drill_path_id: drillActions || "",
      })
      .then((res) => {
        const newData = res?.data?.chart_data || {};
        setData(newData);
        setSpinning(false);
      })
      .catch((err) => {
        console.error("下钻请求失败", err);
      });
  }, []);

  const processTableData = (data) => {
    const columns = [
      ...(metric_fields || []).map((metric) => ({
        title: metric.name,
        dataIndex: metric.field,
        key: metric.field,
        // 可选：如果是数字，可以添加对齐方式
        // align: "right",
      })),
    ];
    // 生成 columns 配置
    if (data?.dim_field) {
      columns.unshift({
        title: dim_field?.name,
        dataIndex: dim_field?.field,
        key: dim_field?.field,
      });
    }

    // 生成 dataSource
    const dataSource = (dData || []).map((row, index) => {
      let rowObj = {};
      if (data?.dim_field) {
        rowObj = {
          key: index, // Antd Table 需要唯一的 key
          [data.dim_field.field]: row[0],
        };
      }
      // const rowObj = {

      // };

      // 动态映射指标字段
      (data.metric_fields || []).forEach((metric, i) => {
        rowObj[metric.field] =
          typeof row[i  + 1] === "number"
            ? row[i + 1].toLocaleString()
            : row[i + 1];
      });

      return rowObj;
    });
    console.log(columns,dataSource,"这个表格列和数据是啥")

    return { columns, dataSource };
  };

  const { columns, dataSource } = processTableData(data);
  console.log(columns,dataSource)
  return (
    <div
      style={{
        maxHeight: "500px",
        minHeight: "500px",
      }}
    >
      <Spin spinning={spinning}>
        <Table
            bordered
          columns={columns}
          dataSource={dataSource}
          pagination
          scroll={{
            x: "max-content",
            y:"400px"
          }}
        />
      </Spin>
    </div>
  );
}

export default DetailTable;
